var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29.4265,
    rx: 14.5,
    fill: "white",
    fillOpacity: 0.93
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.164154,
    y: 0.164154,
    width: 28.6717,
    height: 29.0982,
    rx: 14.3358,
    stroke: "white",
    strokeOpacity: 0.72,
    strokeWidth: 0.328307
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6855 10.4019C13.0592 9.3082 14.5705 9.27507 15.0136 10.3026L15.0511 10.4026L15.5555 11.8776C15.6711 12.2158 15.8578 12.5254 16.1032 12.7853C16.3486 13.0453 16.6469 13.2496 16.978 13.3844L17.1136 13.4351L18.5886 13.9388C19.6823 14.3126 19.7155 15.8238 18.6886 16.2669L18.5886 16.3044L17.1136 16.8088C16.7752 16.9243 16.4655 17.1111 16.2055 17.3565C15.9454 17.6019 15.741 17.9002 15.6061 18.2313L15.5555 18.3663L15.0517 19.8419C14.678 20.9357 13.1667 20.9688 12.7242 19.9419L12.6855 19.8419L12.1817 18.3669C12.0662 18.0286 11.8795 17.7189 11.6341 17.4588C11.3887 17.1988 11.0903 16.9944 10.7592 16.8594L10.6242 16.8088L9.14922 16.3051C8.05485 15.9313 8.02172 14.4201 9.04922 13.9776L9.14922 13.9388L10.6242 13.4351C10.9625 13.3195 11.272 13.1327 11.532 12.8873C11.7919 12.6419 11.9962 12.3436 12.1311 12.0126L12.1817 11.8776L12.6855 10.4019ZM13.8686 10.8057L13.3648 12.2807C13.1888 12.7965 12.9025 13.2678 12.5258 13.6616C12.1491 14.0555 11.6911 14.3625 11.1836 14.5613L11.0273 14.6182L9.55235 15.1219L11.0273 15.6257C11.5432 15.8017 12.0144 16.088 12.4083 16.4647C12.8022 16.8414 13.1092 17.2995 13.308 17.8069L13.3648 17.9632L13.8686 19.4382L14.3723 17.9632C14.5484 17.4474 14.8347 16.9761 15.2114 16.5823C15.5881 16.1884 16.0461 15.8814 16.5536 15.6826L16.7098 15.6263L18.1848 15.1219L16.7098 14.6182C16.194 14.4422 15.7228 14.1559 15.3289 13.7792C14.935 13.4025 14.628 12.9444 14.4292 12.4369L14.373 12.2807L13.8686 10.8057ZM18.8686 8.24695C18.9855 8.24695 19.1001 8.27975 19.1993 8.34162C19.2985 8.40349 19.3784 8.49195 19.4298 8.59695L19.4598 8.67007L19.6786 9.31132L20.3205 9.53007C20.4376 9.56988 20.5404 9.64358 20.6156 9.74183C20.6909 9.84008 20.7352 9.95846 20.7431 10.082C20.751 10.2055 20.7221 10.3285 20.66 10.4356C20.5979 10.5426 20.5054 10.6288 20.3942 10.6832L20.3205 10.7132L19.6792 10.9319L19.4605 11.5738C19.4206 11.691 19.3468 11.7936 19.2485 11.8688C19.1503 11.944 19.0319 11.9883 18.9084 11.9961C18.7849 12.004 18.6618 11.975 18.5548 11.9128C18.4478 11.8506 18.3617 11.7581 18.3073 11.6469L18.2773 11.5738L18.0586 10.9326L17.4167 10.7138C17.2995 10.674 17.1968 10.6003 17.1216 10.5021C17.0463 10.4038 17.0019 10.2854 16.994 10.1619C16.9861 10.0384 17.0151 9.91537 17.0772 9.80833C17.1393 9.7013 17.2318 9.61511 17.343 9.5607L17.4167 9.5307L18.058 9.31195L18.2767 8.67007C18.3189 8.54659 18.3986 8.43939 18.5047 8.36351C18.6109 8.28763 18.7381 8.24687 18.8686 8.24695Z",
    fill: "url(#paint0_linear_368_1377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_1377",
    x1: 3.4834,
    y1: 9.10938,
    x2: 14.499,
    y2: 19.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo2);
export default __webpack_public_path__ + "static/media/AiLogo2.23dca6413bfd18a3de59fcb1a6fb5989.svg";
export { ForwardRef as ReactComponent };